const home = { name: "Home", url: "/Online/Default.aspx"};
const dispatch = { name: "Dispatch", url: "/App/Consignments" };

export { home, dispatch };
